"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphqlClient = void 0;
const base_client_1 = require("@deliverr/base-client");
class GraphqlClient extends base_client_1.ApiClient {
    constructor(config) {
        super(config);
    }
    async query(query, authToken, variables) {
        const graphqlQuery = {
            query,
            variables,
        };
        const headers = {
            "content-type": "application/json",
            Authorization: authToken,
        };
        return this.postWithHeaders("", graphqlQuery, undefined, headers).catch((error) => {
            throw error;
        });
    }
}
exports.GraphqlClient = GraphqlClient;
//# sourceMappingURL=GraphqlClient.js.map